import React, { useState, useEffect, useCallback } from 'react';
import {
	Card,
	TranslatedString,
	useAjax,
	XhrStatus,
	PrimaryButton
} from '@bosch/bt-ui';

import './SimDeactivatePage.css';
import withErrorHandler from '../../components/ErrorHandler';
import ConfirmDialog from '../../components/ConfirmDialog';
import { prepareLogData } from '../../components/Util';

const SimDeactivatePage = (props) => {
	const {
		subTask,
		setSubTask,
		token,
		formValues,
		runAjax
	} = props;

	const [openConfirm, setConfirmOpen] = useState(false);
	const [disableSubmit, setSubmitDisable] = useState(false);

	const onOpenModal = () => setConfirmOpen(true);
	const onFormSubmit = useCallback(
        () => {
			const data = prepareLogData(token,'SIM_Management', 'SIM Management->SIM Deactivation -> Deactivate ' + formValues.SimId);

			setSubTask('SimDeactivatePage');
			setConfirmOpen(false);
			setSubmitDisable(true);
			runAjax('POST', SUPPORTCONSOLE_API_URL + '/api/simmanagement/v1/deactivate/' + formValues.SimId, null, undefined, { 'Authorization': 'Bearer ' + token.token });
			
			//Add activity log
			fetch(SUPPORTCONSOLE_API_URL + '/api/activity/v1/activitylog', {
				method: 'POST',
				headers: {
				  'Content-Type': 'application/json',
				  'Authorization': 'Bearer ' + token.token
				},
				body: JSON.stringify(data)
			  })
        },
        [formValues]
    );

	useEffect(() => {
		setSubmitDisable(true);
    }, [formValues]);

	return (
		<Card
			htmlAttributes={{
				id: "sim-deactivate",
				className: 'sim-deactivate-page'
			}}
		>
			<div className="caption font-large"><TranslatedString stringId="caption-sim-deactivate" /></div>
			<div className="sim-deactivate-note"><TranslatedString stringId="note-sim-deactivate" /></div>
			<div className="sim-deactivate-body">
				<div className="sim-input-field">{formValues.SimId}</div>
				<div className="sim-deactivate-submit">
					<PrimaryButton type="button" onClick={onOpenModal} disabled={disableSubmit}>
						<TranslatedString stringId="button-deactivate" />
					</PrimaryButton>
					<ConfirmDialog openConfirm={openConfirm} setConfirmOpen={setConfirmOpen} onConfirm={onFormSubmit} />
				</div>
			</div>
		</Card>
	);
};

export default withErrorHandler(React.memo(SimDeactivatePage));